import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import HeroSliderOneItem from "./HeroSliderOneItem";
import ReactPlayerComponent from "../react-player/ReactPlayer";
import useWindowSize from "../../util/custom-hooks/useWindowSize";
import DynamicLink from "../../common/DynamicLink";

const HeroSliderOneSingle = ({ data, sliderClassName, indexValue, VideoPlay, bannerTimer }) => {
  const [windowWidth] = useWindowSize();
  const [leftImageSplace, setLeftImageSplace] = useState(0)
  const [rightImageSplace, setRightImageSplace] = useState(0)
  const [isSmallScreen, setIsSmallScreen] = useState(windowWidth < 768);
  const [displayImgBanner, setdisplayImgBanner] = useState('none')
  const [loadComp, setLoadComp] = useState(false)

  let bannerWidth = (data?.background_mobile_image_size && windowWidth && windowWidth < 768) ? data?.background_mobile_image_size : data?.background_image_size

  useEffect(() => {
    if(windowWidth > 0)
    {
      if (windowWidth < 768) {
        setIsSmallScreen(true);
      } else {
        setIsSmallScreen(false);
      }
      setdisplayImgBanner('block');
    } else {
      setdisplayImgBanner('none');
    }
  }, [windowWidth]);

  useEffect(() => {
    if (Number(data.innerImageLeftRightSpace) > 0) {
      if (data.popupImageAlign == 'right') {
        setRightImageSplace(data.innerImageLeftRightSpace)
      } else {
        setLeftImageSplace(data.innerImageLeftRightSpace)
      }
    }
  }, [data.innerImageLeftRightSpace])

  useEffect(()=>{
    if ( bannerTimer !== null ) {
      setTimeout(()=>{
        setLoadComp(true)
      }, 100)
    }
  }, [bannerTimer])

  const bannerLayoutData = () => {
    return <>
    {
      bannerTimer !== null && loadComp && <div className="container-fluid bannerDivWithContainer" >
          <div className="row">
            <HeroSliderOneItem data={data} />{" "}
          </div>
        </div>
    }</>
  }

  return (
      <>
              <div
                  className={` ${indexValue === 0 ? "swiper-slide-active" : ""
                  } slider_item ${data.popupImageAlign === "right" ? "" : "slider_spring"}  single-slider  d-flex ${sliderClassName ? sliderClassName : ""
                  }`}
                  style={{ background: `${data.bgColor} ` }}    
              >
                {data.videoLink ? (
                    <ReactPlayerComponent data={data} sliderClassName={sliderClassName} VideoPlay={VideoPlay} />
                ) : (
                  <div className="w-100 bg-img-block" style={{ display : `${displayImgBanner}`, padding: `0 ${bannerWidth}px` }} >
                    {
                      isSmallScreen === true && data.mobile_banner_image && data.mobile_banner_image !== "undefined" && data.mobile_banner_image !== "" ?
                          <img src={`${process.env.PUBLIC_URL + data.mobile_banner_image}`} className="antera-banner-image bannerImg"/>
                          : data.image_file && (
                          <img src={`${process.env.PUBLIC_URL + data.image_file}`} className="antera-banner-image bannerImg"/>
                      )
                    }
                    {data.popupImage !== undefined && data.popupImage !== "" && (
                        <img className="animated" src={data.popupImage} style={{
                          position: "absolute", maxHeight: "100%", width: " auto", right: 0, maxWidth: "50%", top: "50%", marginLeft: leftImageSplace + "%", marginRight: rightImageSplace + "%", transform: "translateY(-50%)"
                        }} />
                    )}


                    {!data.image_file && (
                        <div style={{ height: "500px", background: `${data.bgColor} ` }}></div>
                    )}
                  </div>
                )}
                {data?.bannerImageLink ? <DynamicLink href={data?.bannerImageLink} className="bannerImageLink">{bannerLayoutData()}</DynamicLink> :
                  <>
                    {bannerLayoutData()}
                  </>
                }
              </div>
      </>
  );
};

HeroSliderOneSingle.propTypes = {
  data: PropTypes.object,
  sliderClassName: PropTypes.string,
};

export default HeroSliderOneSingle;
